import 'css-chunksrc/client/common/profileNavigation/styles.scss';export default {
  "profileNavigation": "_profileNavigation_1qo67_1",
  "user": "_user_1qo67_5",
  "avatar": "_avatar_1qo67_15",
  "name": "_name_1qo67_20",
  "menu": "_menu_1qo67_25"
};